import { http } from '@/utils/http';
import qs from 'qs';
// 页面参数
export function getPrize(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=prize-all-data');
}
// 是否可以兑换
export function ifPrize(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=if-prize');
}
